<template lang="pug">
  div
    p.is-size-7
      | Libre &nbsp
      VbSwitch(type='dark' size='medium' v-model='checado' disabled="disabled")
      | &nbsp Operando
</template>

<script>
  import VbSwitch from 'vue-bulma-switch'
  
  export default {
    name: 'switch_llenaderas',
    components: {
      VbSwitch,
    },
    props: {
      estado: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        checado: false,
      }
    },
    methods: {
      iniciarComponente() {
        console.log('Se inicio componente')
        console.log(this.estado)
        if (this.estado === '1' ) {
          this.checado = false
        } else {
          this.checado = true
        }
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/estaciones_Componentes/layouts/switch_llenaderasIrge.vue